import React, { Component } from "react";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from "@material-ui/core/Snackbar";

import Header from "../../header/Header";
import { generalS } from "../../../strings/general";
import DetailHandler from "./DetailHandler";
import {
  createPost, getPostByPostId, updatePost, deletePostById
} from "../../general_functions/cpanelFunctions";
import { languageConvertor } from "../../general_functions/general"
import {
  getPostsByLanguage,
} from "../../general_functions/general";

import "../../../styles/css/main.css";
import "../../../styles/css/search.css";
import { image } from "d3";
import { host } from '../../../inv';

// change imagename in backend to array
// prepare inmage array name here

class PostMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      name: "",
      details: [],
      fileNames: [],
      currentLang: '...',
      data: [], // language: "", value: {}
      counter: 0,
      uploadFiles: [],
      posts: [],
      stateUpdate: 0,
      imgState: false,
      postId: 0,
      _id: 0,
      loadingImage: false,
      snackbarText: "",
      openSnackbar: false,
      formState: true,
    }
  }

  componentDidMount() {
    let { language } = this.props.context;
    getPostsByLanguage(languageConvertor(language), res => {
      let { post } = res;
      let temp = [];
      let tempObj = {}
      if (post) {
        for (let i = 0; i < post.length; i++) {
          tempObj = post[i].data.value;
          tempObj._id = post[i]._id;
          tempObj.postId = post[i].postId;
          tempObj.fileNames = post[i].fileNames
          temp.push(tempObj)
        }

        this.setState({ posts: temp })
      }
    });
  }

  handleChange = event => {
    this.setState({ type: event.target.value });
  };

  handleLanguage = event => {
    let currentLang = event.target.value;

    let { data } = this.state;
    if (data && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        if (currentLang == data[i].language) {
          this.setState({
            title: data[i].value.title,
            subTitle: data[i].value.subTitle,
            video: data[i].value.video,
            details: data[i].value.details,
            day: data[i].value.day,
            month: data[i].value.month,
            mobile: data[i].value.mobile,
            email: data[i].value.email,
          })
          break;
        } else {
          this.setState({
            title: "", subTitle: "", details: []
          })
        }
      }
    }

    this.setState({ currentLang, formState: true });
  };

  inputHandler = name => event => {
    this.setState({ [name]: event.target.value });
  };

  saveHandler = () => {
    let { data, uploadFiles, stateUpdate, postId, _id, fileNames, type, formState } = this.state;
    let counter = 0;
    // show loading image
    this.setState({ loadingImage: true })
    if (formState) {
      alert("You haven't changed anything! please, after change the post press done!");
      return;
    }

    Object.values(data).map((d, i) => {
      if (d.value.title) { counter = counter + 1; }
    });

    let co = true;
    if (counter < 3) {
      co = window.confirm("You didnt add data for all languages, are you sure you want to save it!");
    }

    let dataObj = { data, fileNames };
    if (co) {
      if (uploadFiles.length > 0) {
        const dataForm = new FormData();
        for (let i = 0; i < uploadFiles.length; i++) {
          let file = uploadFiles[i];
          dataForm.append('files', file);
          dataForm.append('filenames', fileNames[i]);
        }
        fetch(`${host}/post/uploadimage`, {
          method: 'POST',
          body: dataForm,
        }).then((response) => {
          if (response.status == 200) {
            if (stateUpdate == 0) {
              this.createHandler(dataObj)
            } else {
              dataObj.postId = postId;
              dataObj._id = _id;
              this.uploadHadler(dataObj)
            }
          }
        });
      } else {
        if (stateUpdate == 0) {
          this.createHandler(dataObj)
        } else {
          dataObj.postId = postId;
          dataObj._id = _id;
          this.uploadHadler(dataObj)
        }
      }
    }
  }

  createHandler = (dataObj) => {
    createPost(dataObj, res => {
      if (res.success) {
        this.setState({
          openSnackbar: true, snackbarText:
            "post has been saved succesfuly!"
        })
        this.resetForm();
      } else {
        this.setState({
          openSnackbar: true, snackbarText:
            "Something went wrong!"
        })
      }
    });
  }

  uploadHadler = (dataObj) => {
    updatePost(dataObj, res => {
      if (res.success) {
        this.setState({
          openSnackbar: true, snackbarText:
            "post has been saved succesfuly!"
        })
        this.resetForm();
      } else {
        this.setState({
          openSnackbar: true, snackbarText:
            "Something went wrong!"
        })
      }
    });
  }

  addDataHandler = () => {
    let { currentLang, title, subTitle, type,
      video, details, data,
      counter, uploadFiles, stateUpdate, day, month, year, mobile, email } = this.state;

    this.setState({ formState: false })
    if (type == "") {
      alert("please choose the type of the post");
      return;
    }

    if (details.length == 0) {
      alert("please file out detail the detail field!");
      return;
    }

    // if (stateUpdate == 0 && uploadFiles.length == 0 && type != "calender") {
    //   alert("please, choose an image!");
    //   return;
    // }

    let currentData = {
      title, subTitle, type, video, details, day, month, year, mobile, email
    }

    if (data.length == 0) {
      data.push({
        language: currentLang, value: currentData
      })
    } else {
      for (let i = 0; i < data.length; i++) {
        if (data[i].language == currentLang) {
          data[i].value = currentData;
          return;
        }
      }
      data.push({
        language: currentLang, value: currentData
      })
    }

    this.setState({
      title: "", data, subTitle: "", details: [],
      counter: counter + 1, day: 0, month: 0, year: 0, mobile: '', email: ''
    })
  }

  resetForm = () => {
    this.setState({
      type: "",
      title: "",
      subTitle: "",
      video: "",
      details: [],
      fileNames: [],
      currentLang: '...',
      data: [],
      counter: 0,
      uploadInput: '',
      stateUpdate: 0,
      day: 0,
      month: 0,
      year: 0,
      mobile: '',
      email: '',
      loadingImage: false,
      formState: true,
    })
  }

  fileInputHandler = (event) => {
    let { uploadFiles, fileNames } = this.state;
    let uploadFilesTemp = [];
    let fileNamesTemp = [];

    let tempFiles = event.target.files;
    if (fileNames.length > 0) {
      fileNamesTemp = fileNames.filter((value, i, arr) => i === 0);
      uploadFilesTemp = uploadFiles.filter((value, i, arr) => i === 0);
    }

    for (let i = 0; i < tempFiles.length; i++) {
      uploadFilesTemp.push(tempFiles[i])
      fileNamesTemp.push(`${tempFiles[i].lastModified}_${tempFiles[i].name}`);
    }

    this.setState({
      uploadFiles: uploadFilesTemp,
      fileNames: fileNamesTemp
    });
  }

  fileInputCoverHandler = (event) => {
    let { uploadFiles, fileNames } = this.state;
    let tempFiles = event.target.files;

    fileNames[0] = `${tempFiles[0].lastModified}_${tempFiles[0].name}`
    uploadFiles[0] = tempFiles[0];
    this.setState({ uploadFiles, fileNames });
  }

  searchHandler = (event, values) => {
    if (values) {
      this.setState({
        postId: values.postId,
        _id: values._id,
        fileNames: values.fileNames,
      });

      getPostByPostId(values.postId, res => {
        if (res.post) {
          let data = res.post.data;
          let v = data[0].value;
          let currentLang = data[0].language;
          this.setState({
            type: v.type, data,
            stateUpdate: 1, counter: 1
          })
        }
      })
    } else {
      this.setState({ stateUpdate: 0, counter: 0 })
    }
  };

  deleteHandler = () => {
    let { postId } = this.state;

    let co = window.confirm("Are you sure to delete!");
    if (co) {
      deletePostById({ postId }, res => {
        if (res.data.success) {
          this.setState({
            openSnackbar: true, snackbarText:
              "post has been Deleted!"
          })
          this.resetForm();
        } else {
          this.setState({
            openSnackbar: true, snackbarText:
              "Something went wrong!"
          })
        }
      });
    }
  }

  buttonManager = () => {
    let { counter, stateUpdate, loadingImage } = this.state;
    if (counter >= 1 && stateUpdate == 0) {
      if (!loadingImage) {
        return <Button onClick={this.saveHandler}> Save</Button>
      } else {
        return <CircularProgress style={{ color: 'red' }} disableShrink />
      }
    } else if (counter >= 1 && stateUpdate == 1) {
      if (!loadingImage) {
        return (
          <div>
            <Button onClick={this.saveHandler}>Update</Button>
            <Button onClick={this.deleteHandler}>Delet</Button>
          </div>
        )
      } else {
        return (
          <div>
            <Button onClick={this.saveHandler}>Update</Button>
            <Button onClick={this.deleteHandler}>Delet</Button>
          </div>
        )
      }
    } else {
      return ("");
    }
  }

  render() {
    let { context } = this.props;
    let { language } = context;
    let { type, data, currentLang, details, day, month, year,
      title, subTitle, video, posts, openSnackbar, snackbarText,
      mobile, email } = this.state;
    return (
      <div className={"page-controler"}>
        {/* <Header context={context} /> */}

        <Snackbar
          open={openSnackbar}
          message={snackbarText}
          autoHideDuration={2000}
          onClose={() => this.setState({ openSnackbar: false })}
          onRequestClose={() => this.setState({ openSnackbar: false })}
        />
        <div className={"wrapper"}>
          <div style={{ marginBottom: 24 }}>
            Update post
            <Autocomplete
              id="combo-box-demo"
              options={posts}
              onChange={this.searchHandler}
              getOptionLabel={option => {
                if (option.title == 'undefined' || option.title == undefined) {
                  return `No title-${option.type}`;
                } else {
                  return `${option.title}-${option.type}`;
                }
              }}
              style={{ width: "50%", paddingBottom: 24 }}
              renderInput={params => <TextField {...params} label="Combo box" variant="outlined" />}
            />
            <hr style={{ width: "50%" }} />
          </div>
          <br />
          <br />
          <div className={"post-main-container"}>
            <div className={"input-container"}>
              <InputLabel id="demo-simple-select-label">Language</InputLabel>
              <Select
                style={{ width: "100%" }}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={currentLang}
                onChange={this.handleLanguage}
              >
                <MenuItem value={"..."}>...</MenuItem>
                <MenuItem value={"En"}>En</MenuItem>
                <MenuItem value={"Ar"}>Ar</MenuItem>
                <MenuItem value={"Kr"}>Kr</MenuItem>
              </Select>
            </div>
            <div className={"input-container"}>
              <InputLabel id="demo-simple-select-label">Type</InputLabel>
              <Select
                style={{ width: "100%" }}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={type}
                onChange={this.handleChange}
              >
                <MenuItem value={"products"}>{generalS.product[language]}</MenuItem>
                <MenuItem value={"latestProject"}>{generalS.latestNewsAndEvents[language]}</MenuItem>
                <MenuItem value={"aboutus"}>{generalS.about[language]}</MenuItem>
                <MenuItem value={"addresses"}>{generalS.address[language]}</MenuItem>
                <MenuItem value={"homeAlbum"}>{generalS.homeAlbum[language]}</MenuItem>
                <MenuItem value={"homeImageDivider"}>{generalS.homeImageDivider[language]}</MenuItem>
                <MenuItem value={"footerText"}>{generalS.footerText[language]}</MenuItem>
              </Select>
            </div>
            {type == 'calender' ?
              <div className={"cpanel-calender-container"}>
                <div className={"input-container small"}>
                  <label>{generalS.day[language]}</label>
                  <TextField
                    value={day}
                    className={"search-input"} type="number"
                    onChange={this.inputHandler("day")} placeholder={"d"} />
                </div>
                <div className={"input-container small"}>
                  <label>{generalS.month[language]}</label>
                  <TextField
                    value={month}
                    className={"search-input"} type="number" onChange={this.inputHandler("month")}
                    placeholder={"m"} />
                </div>
                <div className={"input-container small"}>
                  <label>{generalS.year[language]}</label>
                  <TextField
                    value={year}
                    className={"search-input"} type="number" onChange={this.inputHandler("year")}
                    placeholder={"yyyy"} />
                </div>
              </div>
              : ("")}
            <div className={"input-container"}>
              <label>Title</label>
              <TextField value={title}
                required className={"search-input"} type="text" onChange={this.inputHandler("title")} />
            </div>
            <div className={"input-container"}>
              <label>sub-title</label>
              <TextField value={subTitle}
                required className={"search-input"} type="text" onChange={this.inputHandler("subTitle")} />
            </div>
            <div className={"input-container"}>
              <label>Image Cover</label>
              <input type="file" name="file"
                accept=".png,.jpg,.jpeg"
                onChange={this.fileInputCoverHandler} multiple />
            </div>
            <div className={"input-container"}>
              <label>Images </label>
              <input type="file" name="file"
                accept=".png,.jpg,.jpeg"
                onChange={this.fileInputHandler} multiple />
            </div>
            {type == 'teamMembers' ?
              <div className={"cpanel-calender-container"}>
                <div className={"input-container small"}>
                  <label>{generalS.mobile[language]}</label>
                  <TextField
                    value={mobile}
                    className={"search-input"} type="number"
                    onChange={this.inputHandler("mobile")} />
                </div>
                <div className={"input-container medium"}>
                  <label>{generalS.email[language]}</label>
                  <TextField
                    value={email}
                    className={"search-input"} type="email"
                    onChange={this.inputHandler("email")}
                    p />
                </div>
              </div>
              : ("")}
            <div className={"input-container"}>
              <label>Video Url</label>
              <input required value={video}
                className={"search-input"} type="text" onChange={this.inputHandler("video")} />
            </div>
            <div className={"input-container"}>
              <DetailHandler context={context} listHandler={(list) => {
                this.setState({ details: list })
              }} details={details} />
            </div>
            <div style={{ width: '100%', display: 'flex', }}>
              {data && data.length > 0 ?
                data.map((d, i) => {
                  return (<p style={{ marginLeft: 48, marginRight: 48 }}>{d.language}</p>)
                }) : ("")
              }
            </div>

            <Button onClick={this.addDataHandler}>
              Done
            </Button>

            {this.buttonManager()}
          </div>
        </div>
      </div>
    );
  }
}

export default PostMain;
